// helpers
import { getCloudinaryRawUrl } from "@swiggy-private/js-utils";
import { isCategoryInstamart } from "@payment-client/helpers/Misc";

// constants
import { IM_ORDER_PLACED_TRANSITION_LOTTIE_ASSET_ID } from "@payment-client/constants/ConfirmScreen";

export const getTickScreenTransitionLottieUrl = () => {
    if (isCategoryInstamart()) {
        return getCloudinaryRawUrl(IM_ORDER_PLACED_TRANSITION_LOTTIE_ASSET_ID);
    }
};

export const showDeliveryAddress = () => {
    if (isCategoryInstamart()) {
        return true;
    }
};

export const getMaxLinesForDeliveryAddress = () => {
    if (isCategoryInstamart()) {
        return 3;
    }
};
